import { useState, useEffect, useCallback } from 'react';
import { CountryCode } from '../types';
import { ApiClient } from '@utils/apiClient';
import { handleApiResult, handleApiCatch } from '@utils/apiErrorHandler';

export const useCountryCodes = () => {
  const [countryCodes, setCountryCodes] = useState<CountryCode[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCountryCodes = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await ApiClient.get('/telephony/country-codes/');
      const result = await handleApiResult<CountryCode[]>(
        response,
        'Failed to fetch country codes'
      );

      if (result.success && result.data) {
        setCountryCodes(result.data);
      } else {
        setError(result.errors?.generalError || 'Failed to fetch country codes');
      }
    } catch (err) {
      const processedErrors = handleApiCatch(err, 'Failed to fetch country codes');
      setError(processedErrors.generalError || 'Failed to fetch country codes');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCountryCodes();
  }, [fetchCountryCodes]);

  return {
    countryCodes,
    loading,
    error,
    fetchCountryCodes,
  };
};
